module.exports = __webpack_public_path__ + "img/icon-email-light-white.c4e614da.svg";